import { de_CreateOrderCommand, se_CreateOrderCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
export { $Command };
export class CreateOrderCommand extends $Command.classBuilder()
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
    ];
})
    .s("Api", "CreateOrder", {})
    .n("ApiClient", "CreateOrderCommand")
    .f(void 0, void 0)
    .ser(se_CreateOrderCommand)
    .de(de_CreateOrderCommand)
    .build() {
}
